 
import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { observer } from 'mobx-react';
import React, { useEffect, useRef, useState } from 'react';
import Loader from '../../_components/molecules/Loader';
import { patientAccessTheme } from '@HomaHealth/ui-component-library';
import {
  TextField,
  Typography,
} from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import {
  Back,
  Button,
  ConfirmationPopup,
  DashedStandardDropdown,
  Delete,
  Download,
  Exclamation,
  PageTitleAndSubTitle,
  Tick,
  Upload,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import {
  // IMPACT_OPTIONS,
  PLAYBOOK_AND_STANDARD_INTERNAL_TABLE_COLUMNS,
  PlaybookAndStandardInternalMessages,
} from '../../core-utils/messages/PlayBookAndStandardInternalConstants';
import properties from '../../core-utils/properties';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import FlaggedProvisionList from '../../_components/organisms/FlaggedProvision';
import { getTextWithToolTip } from '../../core-utils/helper-utils/riskPatientDetailsHelper';
import ReportCreateNewLabelField from '../../_components/atoms/ReportCreateNewLabelField';
import BasicModal from '../../_components/atoms/BasicModal';
import Dropdown from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/Dropdown';
import { getCategoryByFeature } from '../../core-utils/helper-utils/contractAIQHelper';
import { useStores } from '../../stores';
import AutocompleteWithCheckBoxes from '../../_components/atoms/Autocomplete';
import NoPlaybooksData from '../../_components/atoms/Icons/NoPlaybooksData';
import useSnackbar from '../../core-utils/custom-hooks/Snackbar';
import Snackbar from '../../_components/atoms/Snackbar';
import Edit from '../../_components/atoms/Icons/Edit';
import UsersIcon from '../../_components/atoms/Icons/UsersIcon';
import { getPlaybookStatusChip } from '../../core-utils/helper-utils/playbookAndStandardHelper';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

const useStyles = makeStyles()({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: '32px 60px',
    width: '1240px',
  },
  header: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '16px',
  },
  headerTitle: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '4px',
  },
  hr: {
    marginTop: '20px',
    borderBottom: `1px solid ${patientAccessTheme.palette.grey[300]}`,
  },
  mainTableContainer: {
    marginTop: '50px',
  },
  itemContainer: {
    display: 'flex',
    gap: '30px',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
  },
  noDataContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    height: '100%',
    minHeight: '300px',
  },
  alignIcon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '4px',
  },
  titleBtns: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 5,
  },
});

const PlaybookAndStandardInternal = observer(({}) => {
  const { classes } = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const isInitialLoad = useRef(true);
  const employerGroupStore = useStores().employerGroupStore;
  const allGroupEgnid = employerGroupStore.allEmployerGroupsData.map(
    (item: any) => item.eg_nid,
  );
  const eg_nid = employerGroupStore.employerGroupResponseData.eg_nid[0];
  const messages = PlaybookAndStandardInternalMessages;
  const state: any = location.state;
  const contract_id = state.contract_id;
  const document_url = state.document_url;
  const redflag_check = state.redflag_check;
  const service_agreement_name = state.service_agreement_name;
  const isImportanceVisible =
    service_agreement_name &&
    !['Stop-Loss Insurance Provider', 'Broker or Consultant'].includes(
      service_agreement_name,
    );
  const uploadInputRef = useRef<HTMLInputElement>(null);

  const { snackbarState, openSnackbar, handleCloseSnackBar } = useSnackbar();
  const loginPageStore = useStores().loginPageStore;
  const role = loginPageStore.userResponse.role.name;

  // useStates
  const [tableRows, setTableRows] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [selectedGroupIndex, setSelectedGroupIndex] = useState<number | null>(
    null,
  );
  const [selectedItemIndex, setSelectedItemIndex] = useState<number | null>(
    null,
  );
  const [importanceOptions, setImportanceOptions] = useState<string[]>([]);
  const [changedRecords, setChangedRecords] = useState<any[]>([]);
  const [deletedRecords, setDeletedRecords] = useState<any[]>([]);
  const [editFormValues, setEditFormValues] = useState({
    provision_name: '',
    assessment_description: '',
    impact: [] as string[],
    importance: '',
    assessmentrawdesc: '',
    legal_doctorine: '',
    legal_citation: [] as string[],
  });
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [addGroupIndex, setAddGroupIndex] = useState<number | null>(null);
  const [addFormValues, setAddFormValues] = useState({
    provision_name: '',
    assessment_description: '',
    impact: [] as string[],
    importance: 'Mandatory',
    legal_doctorine: '',
    legal_citation: [] as string[],
  });
  const [dropdownValue, setDropdownValue] = useState<string>('Modified');
  const dropdownOptions = ['Default', 'Modified'];
  const [isApplyModalOpen, setIsApplyModalOpen] = useState(false);
  const [applyScope, setApplyScope] = useState<'group' | 'all'>('group');
  const [legalDoctrineOptions, setLegalDoctrineOptions] = useState<string[]>(
    [],
  );
  const [legalCitationOptions, setLegalCitationOptions] = useState<string[]>(
    [],
  );
  const [isSuperAdmin, setIsSuperAdmin] = useState<Boolean>(false);

  // functions
  const fetchFiduciaryList = async () => {
    const result = await axios.get(
      properties.aiqBaseUrl +
        properties.playbookAndStandard +
        properties.getFiduciaryList,
      // {
      //   params: { eg_nid },
      // },
    );
    const data = result.data?.data || {};

    setLegalDoctrineOptions(data.legal_doctrine || []);
    setLegalCitationOptions(data.legal_citation || []);
  };
  const handleFlagToggle = (groupIndex: number, itemIndex: number) => {
    setTableRows((prev) => {
      const updatedRows = prev.map((group, gIdx) =>
        gIdx === groupIndex
          ? {
              ...group,
              items: group.items.map((item: any, iIdx: any) => {
                if (iIdx === itemIndex) {
                  const updatedItem = {
                    ...item,
                    plansponsor: !item.plansponsor,
                  };

                  // Save to changedRecords
                  setChangedRecords((prevChanges) => {
                    // 1. If this item is ADDed and we toggle flag → update the existing added record
                    const addedIndex = prevChanges.findIndex(
                      (x) =>
                        x.type === 'added' &&
                        x.groupIndex === groupIndex &&
                        x.addedItem._id === item._id,
                    );

                    if (addedIndex !== -1) {
                      const updated = [...prevChanges];
                      updated[addedIndex] = {
                        ...updated[addedIndex],
                        addedItem: {
                          ...updated[addedIndex].addedItem,
                          plansponsor: updatedItem.plansponsor,
                        },
                      };
                      return updated;
                    }

                    // 2. If it’s EDITED, update the edited item
                    const existingIndex = prevChanges.findIndex(
                      (x) =>
                        x.type === 'edited' &&
                        x.groupIndex === groupIndex &&
                        x.itemIndex === itemIndex,
                    );

                    if (existingIndex !== -1) {
                      const updatedChanges = [...prevChanges];
                      updatedChanges[existingIndex] = {
                        ...updatedChanges[existingIndex],
                        updatedData: {
                          ...updatedChanges[existingIndex].updatedData,
                          flagStatus: updatedItem.plansponsor,
                        },
                      };
                      return updatedChanges;
                    }

                    // 3. Otherwise append a NEW edited record
                    return [
                      ...prevChanges,
                      {
                        type: 'edited',
                        groupIndex,
                        itemIndex,
                        groupTitle: group.title,
                        _id: item._id,
                        clause: item.clause,
                        key: item.key,
                        updatedData: {
                          provision_name: item.value,
                          assessment_description: item.assessmentrawdesc,
                          impact: item.impactRaw,
                          legal_citation: Array.isArray(item.legal_citation_raw)
                            ? item.legal_citation_raw
                            : typeof item.legal_citation_raw === 'string' &&
                              item.legal_citation_raw.length > 0
                            ? [item.legal_citation_raw]
                            : [],
                          legal_doctorine: Array.isArray(
                            item.legal_doctorine_raw,
                          )
                            ? item.legal_doctorine_raw[0] || ''
                            : typeof item.legal_doctorine_raw === 'string'
                            ? item.legal_doctorine_raw
                            : '',
                          importance: item.importance,
                          flagStatus: updatedItem.plansponsor,
                        },
                      },
                    ];
                  });
                  return updatedItem;
                }
                return item;
              }),
            }
          : group,
      );
      return updatedRows;
    });
  };

  const handleEditAction = (
    action: string,
    groupIndex: number,
    itemIndex: number,
  ) => {
    if (action === 'Edit') {
      const item = tableRows[groupIndex].items[itemIndex];
      setSelectedItem(item);
      setSelectedGroupIndex(groupIndex);
      setSelectedItemIndex(itemIndex);
      setIsModalOpen(true);
    } else if (action === 'Delete') {
      setIsDeleteModalOpen(true);
      setSelectedGroupIndex(groupIndex);
      setSelectedItemIndex(itemIndex);
      setIsDeleteModalOpen(true);
    }
  };

  const handleSaveEdit = () => {
    if (selectedGroupIndex === null || selectedItemIndex === null) {
      return;
    }

    const updatedRows = [...tableRows];
    const oldItem = updatedRows[selectedGroupIndex].items[selectedItemIndex];

    // const updatedItemData = {
    //   provision_name: editFormValues.provision_name,
    //   value: editFormValues.provision_name,
    //   assessment_description: editFormValues.assessment_description,
    //   assessment: getTextWithToolTip(editFormValues.assessment_description, 80),

    //   impact: editFormValues.impact,
    //   importance: editFormValues.importance,
    //   service_agreement_name,
    // };
    const updatedItemData = {
      provision_name: editFormValues.provision_name,
      value: editFormValues.provision_name,

      // ✅ RAW fields (used by modal + payload)
      assessment_description: editFormValues.assessment_description,

      assessmentrawdesc: editFormValues.assessment_description,
      // ✅ ADD THIS LINE
      impact: editFormValues.impact,

      // keep raw as well (UI + safety)
      impactRaw: editFormValues.impact,
      importance: editFormValues.importance,
      legal_citation_raw: editFormValues.legal_citation || [],
      legal_doctorine_raw: editFormValues.legal_doctorine || '',
      legal_citation: editFormValues.legal_citation || [],
      legal_doctorine: editFormValues.legal_doctorine || '',
      service_agreement_name,
    };

    updatedRows[selectedGroupIndex].items[selectedItemIndex] = {
      ...oldItem,
      ...updatedItemData,
      impact: (
        <Grid
          container
          spacing={1}
          sx={{
            alignItems: 'center',
          }}
        >
          {editFormValues.impact.length > 0 ? (
            <>
              {editFormValues.impact.slice(0, 2).map((label, idx) => (
                <Grid key={idx}>{getPlaybookStatusChip(label)}</Grid>
              ))}
              {editFormValues.impact.length > 2 && (
                <Grid>
                  {getPlaybookStatusChip(
                    '+' + (editFormValues.impact.length - 2),
                  )}
                </Grid>
              )}
            </>
          ) : (
            <Grid>
              <Typography
                fontSize="14px"
                textColor={patientAccessTheme.palette.text.mediumemphasis}
              >
                —
              </Typography>
            </Grid>
          )}
        </Grid>
      ),
      assessment: getTextWithToolTip(editFormValues.assessment_description, 80),
      legal_citation:
        editFormValues.legal_citation.length > 0
          ? getTextWithToolTip(editFormValues.legal_citation.join(','), 40)
          : '-',
      legal_doctorine: editFormValues.legal_doctorine
        ? getTextWithToolTip(editFormValues.legal_doctorine, 40)
        : '-',
    };

    setTableRows(updatedRows);

    setChangedRecords((prev) => [
      ...prev.filter(
        (x) =>
          !(
            x.groupIndex === selectedGroupIndex &&
            x.itemIndex === selectedItemIndex
          ),
      ),
      {
        type: 'edited',
        groupIndex: selectedGroupIndex,
        itemIndex: selectedItemIndex,
        groupTitle: updatedRows[selectedGroupIndex].title,
        _id: oldItem._id,
        clause: oldItem.clause,
        key: oldItem.key,
        updatedData: updatedItemData,
      },
    ]);

    setIsModalOpen(false);
  };

  const handleDeleteItem = () => {
    if (selectedGroupIndex === null || selectedItemIndex === null) {
      return;
    }

    const updatedRows = [...tableRows];
    const targetGroup = updatedRows[selectedGroupIndex];
    const deletedItem = targetGroup.items[selectedItemIndex];

    targetGroup.items = targetGroup.items.filter(
      (_: any, idx: any) => idx !== selectedItemIndex,
    );

    updatedRows[selectedGroupIndex] = targetGroup;

    setDeletedRecords((prev) => [
      ...prev,
      {
        type: 'deleted',
        groupTitle: targetGroup.title,
        deletedItem: {
          _id: deletedItem._id,
          clause: deletedItem.clause,
          key: deletedItem.key,
          provision_name: deletedItem.value,
          assessment_description: deletedItem.assessmentrawdesc,
          impact: deletedItem.impactRaw,
          importance: deletedItem.importance,
          value: '-', // default

          category: getCategoryByFeature(redflag_check),
          evidence: deletedItem.evidence || [],
          service_agreement_name: service_agreement_name,
        },
      },
    ]);

    setTableRows(updatedRows);
    setIsDeleteModalOpen(false);
  };

  const handleOpenAddModal = (groupIndex: number) => {
    setAddGroupIndex(groupIndex);

    setAddFormValues({
      provision_name: '',
      assessment_description: '',
      impact: [],
      importance: 'Mandatory',
      legal_doctorine: '',
      legal_citation: [],
    });

    setIsAddModalOpen(true);
  };

  const handleSaveAdd = () => {
    if (addGroupIndex === null) {
      return;
    }

    const updatedRows = [...tableRows];
    const targetGroup = updatedRows[addGroupIndex];

    const newItem = {
      _id: `new_${Date.now()}`,
      clause: targetGroup.title,
      key: addFormValues.provision_name
        ? addFormValues.provision_name.toLowerCase().replace(/\s+/g, '_') +
          `_new_key_${Date.now()}`
        : `new_key_${Date.now()}`,

      plansponsor: false,
      value: addFormValues.provision_name || '—',
      assessment: getTextWithToolTip(addFormValues.assessment_description, 80),
      assessmentrawdesc: addFormValues.assessment_description,
      impactRaw: addFormValues.impact,
      impact: (
        <Grid
          container
          spacing={1}
          sx={{
            alignItems: 'center',
          }}
        >
          {addFormValues.impact.length > 0 ? (
            <>
              {addFormValues.impact.slice(0, 2).map((label, idx) => (
                <Grid key={idx}>{getPlaybookStatusChip(label)}</Grid>
              ))}
              {addFormValues.impact.length > 2 && (
                <Grid>
                  {getPlaybookStatusChip(
                    '+' + (addFormValues.impact.length - 2),
                  )}
                </Grid>
              )}
            </>
          ) : (
            <Grid>
              <Typography
                fontSize="14px"
                textColor={patientAccessTheme.palette.text.mediumemphasis}
              >
                —
              </Typography>
            </Grid>
          )}
        </Grid>
      ),
      importance: addFormValues.importance,
      legal_citation_raw: addFormValues.legal_citation || [],
      legal_doctorine_raw: addFormValues.legal_doctorine || '',
      legal_citation:
        addFormValues.legal_citation.length > 0
          ? getTextWithToolTip(addFormValues.legal_citation.join(','), 40)
          : '-',
      legal_doctorine: addFormValues.legal_doctorine.length
        ? getTextWithToolTip(addFormValues.legal_doctorine, 40)
        : '-',
    };

    targetGroup.items.push(newItem);
    setTableRows(updatedRows);

    setChangedRecords((prev) => [
      ...prev,
      {
        type: 'added',
        groupIndex: addGroupIndex,
        groupTitle: targetGroup.title,
        addedItem: newItem,
      },
    ]);

    setIsAddModalOpen(false);
  };

  const getProvisionData = async () => {
    let skipFinally = false;
    try {
      setLoading(true);
      if (dropdownValue === 'Modified') {
        const isFallingBack = await getAppliedProvisionsData();
        if (isFallingBack) {
          skipFinally = true;
          return;
        }
        return;
      }
      const response = await axios.post(
        properties.aiqBaseUrl +
          properties.contractBaseUrl +
          properties.getDefaultParameters,
        {
          category: getCategoryByFeature(redflag_check),
          service_agreement_name: service_agreement_name,
        },
      );

      const matrixData = response.data?.data || [];

      const filteredData = matrixData.filter(
        (item: any) => item.category === getCategoryByFeature(redflag_check),
      );
      const uniqueImportanceValues: string[] = Array.from(
        new Set(
          filteredData
            .map((i: any) => String(i.importance || '').trim())
            .filter((x: any) => x.length > 0),
        ),
      );

      setImportanceOptions(uniqueImportanceValues);

      const grouped = filteredData.reduce((acc: any, item: any) => {
        const category = item.clause || 'Uncategorized';

        if (!acc[category]) {
          acc[category] = { title: category, items: [] };
        }
        acc[category].items.push({
          _id: item._id,
          clause: item.clause,
          key: item.key,
          plansponsor: true,
          value: item.provision_name || '—',
          assessment:
            getTextWithToolTip(item.assessment_description, 80) || '—',
          assessmentrawdesc: item.assessment_description || '',
          impactRaw: item.impact || [],
          impact: (
            <Grid
              container
              spacing={1}
              sx={{
                alignItems: 'center',
              }}
            >
              {Array.isArray(item.impact) && item.impact.length > 0 ? (
                <>
                  {item.impact.slice(0, 2).map((label: any, idx: any) => (
                    <Grid key={idx}>{getPlaybookStatusChip(label)}</Grid>
                  ))}
                  {item.impact.length > 2 && (
                    <Grid>
                      {getPlaybookStatusChip('+' + (item.impact.length - 2))}
                    </Grid>
                  )}
                </>
              ) : (
                <Grid>
                  <Typography
                    fontSize="14px"
                    textColor={patientAccessTheme.palette.text.mediumemphasis}
                  >
                    —
                  </Typography>
                </Grid>
              )}
            </Grid>
          ),
          importance: item.importance || '—',
          legal_citation_raw: item.legal_citation || [],
          legal_doctorine_raw: item.legal_doctorine || '-',
          legal_citation:
            Array.isArray(item.legal_citation) && item.legal_citation.length > 0
              ? getTextWithToolTip(item.legal_citation.join(','), 40)
              : '-',
          legal_doctorine:
            Array.isArray(item.legal_doctorine) &&
            item.legal_doctorine.length > 0
              ? getTextWithToolTip(item.legal_doctorine.join(','), 40)
              : '-',
        });

        return acc;
      }, {});

      const sortedGroups = Object.values(grouped).sort((a: any, b: any) =>
        a.title.localeCompare(b.title),
      );

      setTableRows(sortedGroups);
    } catch (error) {
      console.error('Failed to fetch matrix data:', error);
      setTableRows([]);
    } finally {
      if (!skipFinally) {
        setLoading(false);
      }
    }
  };

  const getAppliedProvisionsData = async (): Promise<boolean> => {
    try {
      const response = await axios.post(
        properties.aiqBaseUrl +
          properties.playbookAndStandard +
          '/get-applied-provisions',
        {
          eg_nid,
          service_agreement_type: service_agreement_name,
        },
      );

      const rawData = response.data?.data || [];
      if (rawData.length === 0 || rawData[0].matrix_data.length === 0) {
        if (isInitialLoad.current) {
          isInitialLoad.current = false;
          setDropdownValue('Default');
          return true;
        }
        // User manually switched to Modified — show empty screen
        setTableRows([]);
        return false;
      }
      isInitialLoad.current = false;

      // Flatten all matrix_data arrays into a single array
      const data: any[] = rawData.flatMap(
        (item: any) => item.matrix_data || [],
      );
      const grouped = data.reduce((acc: any, item: any) => {
        const category = item.clause || 'Uncategorized';
        if (!acc[category]) {
          acc[category] = { title: category, items: [] };
        }

        const plansponsor =
          typeof item.value === 'boolean' ? item.value : !!item.flagged;

        acc[category].items.push({
          _id: item._id,
          clause: item.clause,
          key: item.key,
          plansponsor,
          value: item.provision_name || '—',
          assessment:
            getTextWithToolTip(item.assessment_description, 80) || '—',
          assessmentrawdesc: item.assessment_description || '',
          impactRaw: item.impact || [],
          impact: (
            <Grid
              container
              spacing={1}
              sx={{
                alignItems: 'center',
              }}
            >
              {Array.isArray(item.impact) && item.impact.length > 0 ? (
                <>
                  {item.impact.slice(0, 2).map((label: any, idx: any) => (
                    <Grid key={idx}>{getPlaybookStatusChip(label)}</Grid>
                  ))}
                  {item.impact.length > 2 && (
                    <Grid>
                      {getPlaybookStatusChip('+' + (item.impact.length - 2))}
                    </Grid>
                  )}
                </>
              ) : (
                <Grid>
                  <Typography
                    fontSize="14px"
                    textColor={patientAccessTheme.palette.text.mediumemphasis}
                  >
                    —
                  </Typography>
                </Grid>
              )}
            </Grid>
          ),
          importance: item.importance || '—',
          legal_citation_raw: item.legal_citation || [],
          legal_doctorine_raw: item.legal_doctorine || '',
          legal_citation:
            Array.isArray(item.legal_citation) && item.legal_citation.length > 0
              ? getTextWithToolTip(item.legal_citation.join(','), 40)
              : '-',
          legal_doctorine:
            Array.isArray(item.legal_doctorine) &&
            item.legal_doctorine.length > 0
              ? getTextWithToolTip(item.legal_doctorine.join(','), 40)
              : '-',
        });

        return acc;
      }, {});

      const sortedGroups = Object.values(grouped).sort((a: any, b: any) =>
        a.title.localeCompare(b.title),
      );

      setTableRows(sortedGroups);
      return false; // loaded fine
    } catch (error) {
      console.error('Failed to fetch applied provisions:', error);
      setTableRows([]);
      return false;
    }
  };

  const buildChangesPayload = () => {
    const added: any[] = [];
    const updated: any[] = [];
    const deleted: any[] = [];

    const isDefaultTab = dropdownValue === 'Default';

    // 🔑 Collect newly added item IDs
    const addedIds = new Set(
      changedRecords
        .filter((x) => x.type === 'added')
        .map((x) => x.addedItem._id),
    );

    // 🔑 Collect edited item IDs
    const editedIds = new Set(
      changedRecords?.filter((x) => x.type === 'edited').map((x) => x._id),
    );

    /**
     * DEFAULT TAB
     */
    if (isDefaultTab) {
      tableRows.forEach((group) => {
        group.items.forEach((item: any) => {
          if (addedIds.has(item._id) || editedIds.has(item._id)) {
            return;
          }

          added.push({
            _id: item._id,
            clause: group.title,
            key: item.key,
            provision_name: item.value,
            assessment_description: item.assessmentrawdesc,
            impact: item.impactRaw || [],
            importance: item.importance,
            category: getCategoryByFeature(redflag_check),
            flagStatus: item.plansponsor,
            document_url,
            service_agreement_name,
            provision_type: 'default',
            legal_doctorine: item.legal_doctorine_raw || '',
            legal_citation: item.legal_citation_raw || [],
          });
        });
      });

      changedRecords
        .filter((x) => x.type === 'added')
        .forEach((rec) => {
          const item = rec.addedItem;
          added.push({
            _id: item._id,
            clause: rec.groupTitle,
            key: item.key,
            provision_name: item.value,
            assessment_description: item.assessmentrawdesc,
            impact: item.impactRaw || [],
            importance: item.importance,
            category: getCategoryByFeature(redflag_check),
            flagStatus: item.plansponsor,
            document_url,
            service_agreement_name,
            provision_type: 'modified',
            legal_doctorine: item.legal_doctorine_raw || '',
            legal_citation: item.legal_citation_raw || [],
          });
        });

      // EDITED → MODIFIED

      changedRecords
        .filter((x) => x.type === 'edited')
        .forEach((rec) => {
          updated.push({
            _id: rec._id,
            clause: rec.groupTitle,
            key: rec.key,
            provision_name: rec.updatedData.provision_name,
            assessment_description: rec.updatedData.assessment_description,
            impact: rec.updatedData.impact || [],
            importance: rec.updatedData.importance,
            category: getCategoryByFeature(redflag_check),
            flagStatus: rec.updatedData.flagStatus,
            document_url,
            service_agreement_name,
            provision_type: 'modified',
            legal_doctorine: rec.updatedData.legal_doctorine || '',
            legal_citation: rec.updatedData.legal_citation || [],
          });
        });

      // DELETED → MODIFIED

      deletedRecords.forEach((rec) => {
        deleted.push({
          ...rec.deletedItem,
          provision_type: 'modified',
        });
      });

      return { added, updated, deleted };
    }

    //  MODIFIED TAB → DIFF ONLY

    changedRecords
      .filter((x) => x.type === 'added')
      .forEach((rec) => {
        const item = rec.addedItem;
        added.push({
          _id: item._id,
          clause: rec.groupTitle,
          key: item.key,
          provision_name: item.value,
          assessment_description: item.assessmentrawdesc,
          impact: item.impactRaw || [],
          importance: item.importance,
          category: getCategoryByFeature(redflag_check),
          flagStatus: item.plansponsor,
          document_url,
          service_agreement_name,
          provision_type: 'modified',
          legal_doctorine: item.legal_doctorine_raw || '',
          legal_citation: item.legal_citation_raw || [],
        });
      });

    changedRecords
      .filter((x) => x.type === 'edited')
      .forEach((rec) => {
        updated.push({
          _id: rec._id,
          clause: rec.groupTitle,
          key: rec.key,
          provision_name: rec.updatedData.provision_name,
          assessment_description: rec.updatedData.assessment_description,
          impact: rec.updatedData.impact || [],
          importance: rec.updatedData.importance,
          category: getCategoryByFeature(redflag_check),
          flagStatus: rec.updatedData.flagStatus,
          document_url,
          service_agreement_name,
          provision_type: 'modified',
          legal_doctorine: rec.updatedData.legal_doctorine || '',
          legal_citation: rec.updatedData.legal_citation || [],
        });
      });

    deletedRecords.forEach((rec) => {
      deleted.push({
        ...rec.deletedItem,
        provision_type: 'modified',
      });
    });

    return { added, updated, deleted };
  };

  const applyChanges = async () => {
    try {
      setLoading(true);
      const egNidsToSend = applyScope === 'all' ? allGroupEgnid : [eg_nid];
      const payload = {
        contract_id,
        eg_nid: egNidsToSend,
        changes: buildChangesPayload(),
      };
      await axios.post(
        properties.aiqBaseUrl +
          properties.playbookAndStandard +
          properties.updateMatrixChanges,
        payload,
      );
      await getProvisionData();
      openSnackbar('Paramter Saved Successfully', 'success', 3000);
      setChangedRecords([]);
      setDeletedRecords([]);
    } catch (error) {
      openSnackbar('Parameter Update Save Error', 'error', 3000);
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(dropdownValue);

    worksheet.columns = [
      { header: 'Key', key: 'Key', width: 25 },
      { header: 'Plan Sponsor Flag', key: 'PlanSponsorFlag', width: 18 },
      { header: 'Clause', key: 'Clause', width: 35 },
      { header: 'Provision Name', key: 'ProvisionName', width: 40 },
      {
        header: 'Assessment Description',
        key: 'AssessmentDescription',
        width: 60,
      },
      { header: 'Legal Citation', key: 'LegalCitation', width: 30 },
      { header: 'Legal Doctrine', key: 'LegalDoctrine', width: 30 },
      { header: 'Importance', key: 'Importance', width: 18 },
    ];

    tableRows.forEach((group) => {
      group.items.forEach((item: any) => {
        worksheet.addRow({
          Key: item?.key,
          PlanSponsorFlag: item.plansponsor ? 'Yes' : 'No',
          Clause: group.title,
          ProvisionName: item.value || '—',
          AssessmentDescription: item.assessmentrawdesc || '—',
          LegalCitation: Array.isArray(item.legal_citation_raw)
            ? item.legal_citation_raw.join(', ')
            : item.legal_citation_raw || '—',
          LegalDoctrine: Array.isArray(item.legal_doctorine_raw)
            ? item.legal_doctorine_raw.join(', ')
            : item.legal_doctorine_raw || '—',
          Importance: item.importance || '—',
        });
      });
    });

    // Optional: bold the header row
    worksheet.getRow(1).font = { bold: true };

    const fileName = `${
      redflag_check || 'Playbook'
    }_${dropdownValue}_${new Date().toISOString().slice(0, 10)}.xlsx`;

    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), fileName);
  };

  const handleUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) {
      return;
    }

    const reader = new FileReader();
    reader.onload = async (event) => {
      try {
        const text = event.target?.result as string;
        const lines = text.trim().split('\n');
        const headers = lines[0].split(',').map((h) => h.trim());

        const csvRows = lines.slice(1).map((line) => {
          const values = line.split(',').map((v) => v.trim());
          return headers.reduce((acc: any, header, idx) => {
            acc[header] = values[idx] ?? '';
            return acc;
          }, {});
        });

        // Build a flat map of ALL existing keys from current tableRows
        const existingKeyMap: Record<string, { item: any; group: any }> = {};
        tableRows.forEach((group) => {
          group.items.forEach((item: any) => {
            if (item.key) {
              existingKeyMap[item.key] = { item, group };
            }
          });
        });

        // ✅ STEP 1 — VALIDATE ROWS (add this block here)
        const validationErrors: string[] = [];
        csvRows.forEach((row, idx) => {
          const rowNum = idx + 2;
          const key = (row['Key'] || row['key'] || '').trim();
          const provisionName = (
            row['Provision Name'] ||
            row['provision_name'] ||
            ''
          ).trim();
          const assessmentDesc = (
            row['Assessment Description'] ||
            row['assessment_description'] ||
            ''
          ).trim();
          const importance = (
            row['Importance'] ||
            row['importance'] ||
            ''
          ).trim();
          const clause = (row['Clause'] || row['clause'] || '').trim();

          // Entirely empty row — skip silently
          const isEntirelyEmpty =
            !key && !provisionName && !assessmentDesc && !importance && !clause;
          if (isEntirelyEmpty) {
            return;
          }

          // Other fields present but key missing
          if (
            !key &&
            (provisionName || assessmentDesc || importance || clause)
          ) {
            validationErrors.push(`Row ${rowNum}: Key is mandatory.`);
            return;
          }
          if (key) {
            if (!provisionName) {
              validationErrors.push(
                `Row ${rowNum} (Key: ${key}): Provision Name is required.`,
              );
            }
            if (!assessmentDesc) {
              validationErrors.push(
                `Row ${rowNum} (Key: ${key}): Assessment Description is required.`,
              );
            }
            if (!importance) {
              validationErrors.push(
                `Row ${rowNum} (Key: ${key}): Importance is required.`,
              );
            }
            if (!clause) {
              validationErrors.push(
                `Row ${rowNum} (Key: ${key}): Clause is required.`,
              );
            }
          }
        });

        // ✅ STEP 2 — STOP if any validation errors
        if (validationErrors.length > 0) {
          openSnackbar(validationErrors[0], 'error', 5000);
          return;
        }

        const added: any[] = [];
        const updated: any[] = [];

        csvRows
          .filter((row) => row['Provision Name'] || row['provision_name'])
          .forEach((row) => {
            const csvKey = row['Key'] || row['key'] || '';
            const isExisting = csvKey && existingKeyMap[csvKey];

            const basePayload = {
              clause: row['Clause'] || row['clause'] || '',
              key:
                csvKey ||
                (row['Provision Name'] || row['provision_name'])
                  .toLowerCase()
                  .replace(/\s+/g, '_') + `_csv_${Date.now()}`,
              provision_name:
                row['Provision Name'] || row['provision_name'] || '',
              assessment_description:
                row['Assessment Description'] ||
                row['assessment_description'] ||
                '',
              impact:
                row['Impact'] || row['impact']
                  ? (row['Impact'] || row['impact'])
                      .split(';')
                      .map((s: string) => s.trim())
                      .filter(Boolean)
                  : [],
              importance: row['Importance'] || row['importance'] || 'Mandatory',
              category: getCategoryByFeature(redflag_check),
              flagStatus:
                (
                  row['Plan Sponsor Flag'] ||
                  row['plan_sponsor_flag'] ||
                  ''
                ).toLowerCase() === 'yes',
              document_url,
              service_agreement_name,
              provision_type: 'modified',
              legal_doctorine:
                row['Legal Doctrine'] || row['legal_doctorine'] || '',
              legal_citation:
                row['Legal Citation'] || row['legal_citation']
                  ? (row['Legal Citation'] || row['legal_citation'])
                      .split(';')
                      .map((s: string) => s.trim())
                      .filter(Boolean)
                  : [],
            };

            if (isExisting) {
              updated.push({
                ...basePayload,
                _id: existingKeyMap[csvKey].item._id,
              });
            } else {
              added.push(basePayload);
            }
          });

        // ✅ STEP 3 — BUILD deleted[] (add this block here, after the forEach)
        const csvKeySet = new Set(
          csvRows
            .filter((row) => row['Key'] || row['key'])
            .map((row) => (row['Key'] || row['key']).trim()),
        );

        const deleted: any[] = [];
        tableRows.forEach((group) => {
          group.items.forEach((item: any) => {
            if (item.key && !csvKeySet.has(item.key)) {
              deleted.push({
                _id: item._id,
                clause: group.title,
                key: item.key,
                provision_name: item.value,
                assessment_description: item.assessmentrawdesc,
                impact: item.impactRaw || [],
                importance: item.importance,
                category: getCategoryByFeature(redflag_check),
                flagStatus: item.plansponsor,
                document_url,
                service_agreement_name,
                provision_type: 'modified',
                legal_doctorine: item.legal_doctorine_raw || '',
                legal_citation: item.legal_citation_raw || [],
              });
            }
          });
        });

        // ✅ STEP 4 — Updated empty check to include deleted
        if (
          added.length === 0 &&
          updated.length === 0 &&
          deleted.length === 0
        ) {
          openSnackbar('No valid rows found in CSV', 'error', 3000);
          return;
        }

        setLoading(true);
        await axios.post(
          properties.aiqBaseUrl +
            properties.playbookAndStandard +
            properties.updateMatrixChanges,
          {
            contract_id,
            eg_nid: [eg_nid],
            changes: { added, updated, deleted }, // ✅ deleted now included
          },
        );

        await getProvisionData();
        // ✅ STEP 5 — Updated snackbar message
        openSnackbar(
          `Upload complete — ${updated.length} updated, ${added.length} added, ${deleted.length} deleted`,
          'success',
          3000,
        );
      } catch (err) {
        console.error('CSV upload failed:', err);
        openSnackbar('CSV upload failed', 'error', 3000);
      } finally {
        setLoading(false);
        if (uploadInputRef.current) {
          uploadInputRef.current.value = '';
        }
      }
    };

    reader.readAsText(file);
  };

  useEffect(() => {
    if (role === 'super_admin') {
      setIsSuperAdmin(true);
    } else {
      setIsSuperAdmin(false);
    }
  }, [role]);

  useEffect(() => {
    if (contract_id && eg_nid) {
      getProvisionData();
    }
  }, [contract_id, dropdownValue, eg_nid]);

  useEffect(() => {
    if (selectedItem) {
      setEditFormValues({
        provision_name: selectedItem.value || '',
        assessment_description: selectedItem.assessmentrawdesc || '',
        impact: Array.isArray(selectedItem.impactRaw)
          ? selectedItem.impactRaw
          : [],
        importance: selectedItem.importance || '',
        assessmentrawdesc: selectedItem.assessmentrawdesc || '',
        legal_doctorine:
          Array.isArray(selectedItem.legal_doctorine_raw) &&
          selectedItem.legal_doctorine_raw.length > 0
            ? selectedItem.legal_doctorine_raw
            : '',
        legal_citation: Array.isArray(selectedItem.legal_citation_raw)
          ? selectedItem.legal_citation_raw
          : [],
      });
    }
  }, [selectedItem]);

  useEffect(() => {
    fetchFiduciaryList();
  }, [eg_nid]);

  return (
    <Grid container className={classes.root}>
      {loading ? (
        <Loader />
      ) : (
        <Grid>
          <PageTitleAndSubTitle
            title={
              <Grid className={classes.header}>
                <Grid className={classes.headerTitle}>
                  <Back
                    width={'18px'}
                    height={'18px'}
                    onClick={() => navigate(-1)}
                    style={{
                      cursor: 'pointer',
                    }}
                  />

                  <Typography
                    fontSize="18px"
                    fontType="semiBold"
                    textColor={patientAccessTheme.palette.text.highemphasis}
                  >
                    {redflag_check}
                  </Typography>
                </Grid>
                <Grid className={classes.alignIcon}>
                  <UsersIcon />
                  <DashedStandardDropdown
                    options={dropdownOptions}
                    displayValue={dropdownOptions}
                    value={dropdownValue}
                    // handleChange={(e) =>
                    //   setDropdownValue(e.target.value as string)
                    // }
                    handleChange={(e) => {
                      setTableRows([]);
                      setLoading(true);
                      setDropdownValue(e.target.value as string);
                    }}
                    width="auto"
                  />
                </Grid>
              </Grid>
            }
            subTitle={messages.MAIN.SUBTITLE}
            customButton={false}
            subTitleStyles={{ width: '1240px' }}
            topRightItem={
              <Grid className={classes.titleBtns}>
                {/* Hidden file input */}
                {isSuperAdmin && (
                  <>
                    <input
                      ref={uploadInputRef}
                      type="file"
                      accept=".csv"
                      style={{ display: 'none' }}
                      onChange={handleUpload}
                    />
                    <Button
                      width="160px"
                      label="Upload Params"
                      variant="contained"
                      startIcon={<Upload width={14} height={14} />}
                      onClick={() => uploadInputRef.current?.click()}
                    />
                  </>
                )}
                {tableRows.length > 0 && (
                  <Button
                    width="180px"
                    label="Download Params"
                    variant="outlined"
                    startIcon={<Download />}
                    onClick={handleDownload}
                  />
                )}
              </Grid>
            }
          />

          <Grid className={classes.hr} />

          <Grid className={classes.mainTableContainer}>
            {tableRows?.length === 0 ? (
              <div className={classes.noDataContainer}>
                <NoPlaybooksData />
                <Typography
                  textColor={patientAccessTheme.palette.text.lowemphasis}
                  fontSize="12px"
                  styleProps={{
                    marginTop: '20px',
                  }}
                >
                  {messages.NO_DATA.CONTENT}
                </Typography>
              </div>
            ) : (
              <FlaggedProvisionList
                tableWidth="1240px"
                // columns={PLAYBOOK_AND_STANDARD_INTERNAL_TABLE_COLUMNS}
                columns={
                  [
                    'Stop-Loss Insurance Provider',
                    'Broker or Consultant',
                  ].includes(service_agreement_name)
                    ? PLAYBOOK_AND_STANDARD_INTERNAL_TABLE_COLUMNS.filter(
                        (col) => col.key !== 'importance',
                      )
                    : PLAYBOOK_AND_STANDARD_INTERNAL_TABLE_COLUMNS
                }
                rows={tableRows}
                onFlagToggle={handleFlagToggle}
                editMenuItems={[
                  { label: 'Edit', icon: <Edit width="20px" height="20px" /> },
                  {
                    label: 'Delete',
                    icon: <Delete width="20px" height="20px" />,
                  },
                ]}
                onAddParameter={handleOpenAddModal}
                onEditAction={handleEditAction}
              />
            )}
          </Grid>
          {tableRows?.length > 0 && (
            <Grid className={classes.buttonContainer}>
              <Button
                label={'Apply for group'}
                variant="contained"
                onClick={() => {
                  setApplyScope('group');
                  setIsApplyModalOpen(true);
                }}
                styleProps={{
                  color: patientAccessTheme.palette.status.white,
                  width: 'auto',
                  height: '42px',
                  marginTop: '20px',
                }}
                endIcon={<Tick color="white" />}
              />
              <Button
                label={'Apply for all group'}
                variant="contained"
                onClick={() => {
                  setApplyScope('all');
                  setIsApplyModalOpen(true);
                }}
                styleProps={{
                  color: patientAccessTheme.palette.status.white,
                  width: 'auto',
                  height: '42px',
                  marginTop: '20px',
                }}
                endIcon={<Tick color="white" />}
              />
              <Button
                label={'Cancel'}
                variant="outlined"
                onClick={async () => {
                  // Discard all unsaved changes
                  setChangedRecords([]);
                  setDeletedRecords([]);
                  // Reload the original provision data
                  await getProvisionData();
                }}
                styleProps={{
                  // color: patientAccessTheme.palette.status.white,
                  width: '121px',
                  // height: '42px',
                  marginTop: '20px',
                }}
              />
            </Grid>
          )}
        </Grid>
      )}
      {/* EDIT MODAL */}
      <BasicModal
        open={isModalOpen}
        width="auto"
        saveBtnDisabled={
          !editFormValues.provision_name?.trim() ||
          !editFormValues.assessment_description?.trim() ||
          !editFormValues.importance?.trim() ||
          !editFormValues.legal_doctorine ||
          editFormValues.legal_citation.length === 0
          // editFormValues.impact.length === 0
        }
        handleClose={() => setIsModalOpen(false)}
        title="Edit Details"
        isSaveButton={true}
        saveBtnText="Save"
        saveBtnAction={() => handleSaveEdit()}
      >
        <Grid className={classes.itemContainer}>
          <ReportCreateNewLabelField
            label="Provision Name"
            component={
              <TextField
                name="value"
                value={editFormValues.provision_name}
                placeholder="Enter Provision Name"
                height="36px"
                width="301px"
                onChange={(e: any) =>
                  setEditFormValues((prev) => ({
                    ...prev,
                    provision_name: e.target.value,
                  }))
                }
              />
            }
          />

          {/* <ReportCreateNewLabelField
            label="Impact"
            component={
              <AutocompleteWithCheckBoxes
                options={IMPACT_OPTIONS}
                defaultValue={editFormValues.impact}
                placeholder="Select Impact"
                width="301px"
                handleChange={(event, value) =>
                  setEditFormValues((prev) => ({ ...prev, impact: value }))
                }
              />
            }
          /> */}
          <ReportCreateNewLabelField
            label="Legal Doctorine"
            component={
              <Dropdown
                label="Legal Doctorine"
                // placeholder="Select Legal Doctorine"
                dropDownOptions={legalDoctrineOptions}
                dropDownValues={legalDoctrineOptions}
                value={
                  editFormValues.legal_doctorine
                    ? editFormValues.legal_doctorine
                    : ''
                }
                handleChange={(event) => {
                  setEditFormValues((prev) => ({
                    ...prev,
                    legal_doctorine: event.target.value as string,
                  }));
                }}
                width="301px"
                selectStyles={{
                  width: '301px',
                }}
              />
            }
          />
        </Grid>

        <Grid className={classes.itemContainer}>
          <ReportCreateNewLabelField
            label="Legal Citation"
            component={
              <AutocompleteWithCheckBoxes
                options={legalCitationOptions}
                defaultValue={editFormValues.legal_citation}
                placeholder="Select Legal Citation"
                width="301px"
                handleChange={(event, value) =>
                  setEditFormValues((prev) => ({
                    ...prev,
                    legal_citation: value,
                  }))
                }
              />
            }
          />
          {service_agreement_name && isImportanceVisible && (
            <ReportCreateNewLabelField
              label="Importance"
              component={
                <Dropdown
                  name="importance"
                  label="Importance"
                  placeholder="Select Importance"
                  value={editFormValues.importance}
                  dropDownOptions={importanceOptions}
                  dropDownValues={importanceOptions}
                  width="301px"
                  height="40px"
                  handleChange={(e: any) =>
                    setEditFormValues((prev) => ({
                      ...prev,
                      importance: e.target.value,
                    }))
                  }
                  selectStyles={{ width: '301px' }}
                />
              }
            />
          )}
        </Grid>
        <Grid className={classes.itemContainer}>
          <ReportCreateNewLabelField
            label="Assessment Description"
            component={
              <TextField
                name="assessment_description"
                value={editFormValues.assessment_description}
                placeholder="Enter Assessment Description"
                multiline={true}
                // width="301px"
                width={isImportanceVisible ? '301px' : '620px'}
                onChange={(e: any) =>
                  setEditFormValues((prev) => ({
                    ...prev,
                    assessment_description: e.target.value,
                  }))
                }
              />
            }
          />
        </Grid>
      </BasicModal>
      {/* ADD MODAL */}
      <BasicModal
        open={isAddModalOpen}
        width="auto"
        handleClose={() => setIsAddModalOpen(false)}
        title="Add Parameter"
        isSaveButton={true}
        saveBtnDisabled={
          !addFormValues.provision_name?.trim() ||
          !addFormValues.assessment_description?.trim() ||
          !addFormValues.importance?.trim() ||
          !addFormValues.legal_citation ||
          addFormValues.legal_doctorine.length < 0
        }
        saveBtnText="Add"
        saveBtnAction={() => handleSaveAdd()}
      >
        <Grid className={classes.itemContainer}>
          <ReportCreateNewLabelField
            label="Provision Name"
            component={
              <TextField
                name="provision_name"
                value={addFormValues.provision_name}
                placeholder="Enter Provision Name"
                height="36px"
                width="301px"
                onChange={(e: any) =>
                  setAddFormValues((prev) => ({
                    ...prev,
                    provision_name: e.target.value,
                  }))
                }
              />
            }
          />
          <ReportCreateNewLabelField
            label="Legal Doctorine"
            component={
              <Dropdown
                label="Legal Doctorine"
                dropDownOptions={legalDoctrineOptions}
                dropDownValues={legalDoctrineOptions}
                value={addFormValues.legal_doctorine}
                handleChange={(event) => {
                  setAddFormValues((prev) => ({
                    ...prev,
                    legal_doctorine: event.target.value as string,
                  }));
                }}
                width="301px"
                selectStyles={{
                  width: '301px',
                }}
              />
            }
          />
        </Grid>
        <Grid className={classes.itemContainer}>
          <ReportCreateNewLabelField
            label="Legal Citation"
            component={
              <AutocompleteWithCheckBoxes
                options={legalCitationOptions}
                defaultValue={addFormValues.legal_citation}
                placeholder="Select Legal Citation"
                width="301px"
                handleChange={(event, value) =>
                  setAddFormValues((prev) => ({
                    ...prev,
                    legal_citation: value,
                  }))
                }
              />
            }
          />
          {service_agreement_name && isImportanceVisible && (
            <ReportCreateNewLabelField
              label="Importance"
              component={
                <Dropdown
                  name="importance"
                  label="Importance"
                  placeholder="Select Importance"
                  value={addFormValues.importance}
                  dropDownOptions={['Mandatory']}
                  dropDownValues={['Mandatory']}
                  width="301px"
                  height="40px"
                  handleChange={(e: any) =>
                    setAddFormValues((prev) => ({
                      ...prev,
                      importance: e.target.value,
                    }))
                  }
                  selectStyles={{ width: '301px' }}
                />
              }
            />
          )}
        </Grid>
        <Grid className={classes.itemContainer}>
          <ReportCreateNewLabelField
            label="Assessment Description"
            component={
              <TextField
                name="assessment_description"
                value={addFormValues.assessment_description}
                multiline={true}
                placeholder="Enter Assessment Description"
                // width="301px"
                width={isImportanceVisible ? '301px' : '620px'}
                onChange={(e: any) =>
                  setAddFormValues((prev) => ({
                    ...prev,
                    assessment_description: e.target.value,
                  }))
                }
              />
            }
          />
        </Grid>
      </BasicModal>
      <BasicModal
        title={'Confirmation'}
        open={isApplyModalOpen}
        handleClose={() => setIsApplyModalOpen(false)}
        saveBtnAction={() => {
          setIsApplyModalOpen(false);
          applyChanges();
        }}
        isSaveButton={true}
        saveBtnText="Apply"
        isCloseBtn={true}
        width="auto"
      >
        <Typography fontSize="14px" margin="10px 0px">
          Are you sure you want to apply the changes ?
        </Typography>
      </BasicModal>
      {isDeleteModalOpen && (
        <ConfirmationPopup
          handleCancel={() => setIsDeleteModalOpen(false)}
          handleConfirm={handleDeleteItem}
          icon={<Exclamation width="38px" height="38px" />}
          title="Delete"
          subTitle="Are you sure you want to delete"
          buttonsType="error"
          width="544px"
          height="280px"
        />
      )}
      <Snackbar
        {...snackbarState}
        handleClose={handleCloseSnackBar}
        vertical="bottom"
        horizontal="right"
      />
    </Grid>
  );
});

export default PlaybookAndStandardInternal;
